import { Box, Grid2 } from '@mui/material';
import IsOnlineComponent from '../../../components/IsOnlineComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import { Add, Link, Share } from '@mui/icons-material';
import React, { useContext, useEffect, useState } from 'react';
import { getStreamByEndpointAsync } from '../../../services/Events';
import { ENDPOINT_SIP_CLIENT } from '../../../services/SipClientService';
import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import {
  ISipClientProps,
  ISipClientRegisterSimpleProps,
} from '../../../services/SipClientService/types';
import SipRegisterEditionModal from './SipRegisterEditionModal';
import ButtonActionsComponent from '../../../components/ButtonActionsComponent';
import {
  useDeleteSipClientAsync,
  useGetSipClientByIdAsync,
} from '../../../services/SipClientService/hooks/useMutation';
import ConfirmDeleteModalComponent from '../../../components/ConfirmDeleteModalComponent';
import { AppContext } from '../../../context/AppContextProvider';
import DeviceLinkWithSipClientEditionModal from '../DeviceLink/DeviceLinkWithSipClientEditionModal';
import DeviceLinkWithSipClient from '../DeviceLink/DeviceLinkWithSipClient';

const SipRegister = () => {
  const [sipRegisters, setSipRegisters] = useState<
    ISipClientRegisterSimpleProps[]
  >([]);
  const [sipClientSelected, setSipClientSelected] = useState<
    ISipClientProps | undefined
  >();
  const { showSnackbar } = useContext(AppContext);
  const [isVisibleRegisterEditionModal, setIsVisibleRegisterEditionModal] =
    useState(false);
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);
  const { mutateAsync: mutateGetSipClientByIdAsync } =
    useGetSipClientByIdAsync();
  const { mutateAsync: mutateDeleteSipClientByIdAsync } =
    useDeleteSipClientAsync();
  const [selectedItemToDelete, setSelectedItemToDelete] = useState<
    ISipClientRegisterSimpleProps | undefined
  >();

  const [isLoading, setIsLoading] = useState(false);

  const columns: IColumnProps[] = [
    {
      label: 'Nome',
      id: 'id',
      render(val) {
        const item = sipRegisters.find((s) => s.id === Number(val));
        if (!item) return <></>;
        return (
          <Box display={'flex'} gap={1}>
            <IsOnlineComponent
              isOnline={item.isRegistered}
              width={20}
              height={20}
            />
            {item.displayName}
          </Box>
        );
      },
    },
    { label: 'Ramal', width: '0%', id: 'username' },
    {
      label: 'Ações',
      width: '0%',
      id: 'id',
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDelete(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const handleEdit = async (id: number) => {
    await mutateGetSipClientByIdAsync(id).then(setSipClientSelected);
    setIsVisibleRegisterEditionModal(true);
  };

  const handleDelete = async (id: number) => {
    setSelectedItemToDelete(sipRegisters?.find((i) => i.id === id));
    setIsVisibleDeleteModal(true);
  };

  const handleCancelDeletion = () => {
    setIsVisibleDeleteModal(false);
    setSipClientSelected(undefined);
  };

  const handleConfirmDeletion = async () => {
    if (selectedItemToDelete?.id) {
      await mutateDeleteSipClientByIdAsync(selectedItemToDelete?.id, {
        onSuccess: (_) => {
          showSnackbar('Ramal excluído com sucesso.', 'success');
        },
      });
      setSelectedItemToDelete(undefined);
      setIsVisibleDeleteModal(false);
    }
  };

  useEffect(() => {
    getStreamByEndpointAsync(
      ENDPOINT_SIP_CLIENT + `/toRegister`,
      setSipRegisters,
      undefined,
      undefined,
      setIsLoading,
    );
  }, []);

  return (
    <Box>
      <Grid2 container columnSpacing={2} rowSpacing={2}>
        <Grid2 size={12}>
          <TableComponent
            rows={sipRegisters}
            columns={columns}
            title={'Ramais com registro no AlertAi'}
            isLoading={isLoading}
            additionalTitleComponent={
              <Box gap={2} display={'flex'}>
                <ButtonComponent
                  size={'small'}
                  startIcon={<Add />}
                  onClick={() => setIsVisibleRegisterEditionModal(true)}
                >
                  Novo registro Ramal
                </ButtonComponent>
              </Box>
            }
          />
        </Grid2>
      </Grid2>
      <SipRegisterEditionModal
        registerSelected={sipClientSelected}
        isOpen={isVisibleRegisterEditionModal}
        onClose={() => {
          setIsVisibleRegisterEditionModal(false);
          setSipClientSelected(undefined);
        }}
      />

      <ConfirmDeleteModalComponent
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
        isVisibleDeleteDialog={isVisibleDeleteModal}
        message={`Tem certeza que deseja deletar o Ramal ${selectedItemToDelete?.displayName} ?`}
        setIsVisibleDeleteDialog={setIsVisibleDeleteModal}
        title={'Deletar Ramal'}
      />
    </Box>
  );
};

export default SipRegister;
